/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for valueOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="valueOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="isNull"/&gt; &lt;enumeration value="greaterThan"/&gt; &lt;enumeration value="greaterEqual"/&gt; &lt;enumeration value="lessThan"/&gt; &lt;enumeration value="lessEqual"/&gt; &lt;enumeration value="notEqual"/&gt; &lt;enumeration value="equal"/&gt; &lt;enumeration value="between"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ValueOperatorType extends Enum{

	enumValue = null;

	static  IS_NULL = ValueOperatorType.newLiteral("isNull");

	static  GREATER_THAN = ValueOperatorType.newLiteral("greaterThan");

	static  GREATER_EQUAL = ValueOperatorType.newLiteral("greaterEqual");

	static  LESS_THAN = ValueOperatorType.newLiteral("lessThan");

	static  LESS_EQUAL = ValueOperatorType.newLiteral("lessEqual");

	static  NOT_EQUAL = ValueOperatorType.newLiteral("notEqual");

	static  EQUAL = ValueOperatorType.newLiteral("equal");

	static  BETWEEN = ValueOperatorType.newLiteral("between");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ValueOperatorType.values().length); ++i) {
			if (ValueOperatorType.values()[i].enumValue == v) {
				return ValueOperatorType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ValueOperatorType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ValueOperatorType.js